export interface INote {
	Title?: string;
	ParentId?: string;
	Body?: string;
	OwnerId?: string;
	IsPrivate?: boolean;
}
